import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, Users, GraduationCap, AlertCircle } from 'lucide-react';

export default function CareersPage() {
  return (
    <div className="flex-grow bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-bold text-gray-900">Join Our Team</h1>
          <p className="mt-4 text-xl text-gray-600 max-w-2xl mx-auto">
            Help us drive sustainable development and climate resilience across Africa.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {[
            {
              icon: Briefcase,
              title: 'Meaningful Work',
              description: 'Make a real impact on climate action and sustainable development.'
            },
            {
              icon: Users,
              title: 'Great Team',
              description: 'Work with passionate experts from diverse backgrounds.'
            },
            {
              icon: GraduationCap,
              title: 'Growth',
              description: 'Continuous learning and development opportunities.'
            }
          ].map((benefit) => (
            <motion.div
              key={benefit.title}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <benefit.icon className="h-8 w-8 text-green-600 mb-4" />
              <h3 className="text-lg font-semibold text-gray-900">{benefit.title}</h3>
              <p className="mt-2 text-gray-600">{benefit.description}</p>
            </motion.div>
          ))}
        </div>

        <div className="bg-white rounded-lg shadow-md p-8 text-center">
          <AlertCircle className="h-16 w-16 text-yellow-500 mx-auto mb-6" />
          <h2 className="text-2xl font-bold text-gray-900 mb-4">No Current Openings</h2>
          <p className="text-gray-600 max-w-2xl mx-auto mb-6">
            While we don't have any positions available at the moment, we're always interested in 
            connecting with talented individuals passionate about climate finance and sustainability.
          </p>
          <div className="space-y-4">
            <p className="text-gray-600">You can:</p>
            <ul className="text-gray-600 space-y-2">
              <li>• Submit your CV for future opportunities</li>
              <li>• Follow us on LinkedIn for updates</li>
              <li>• Subscribe to our newsletter</li>
            </ul>
          </div>
          <button className="mt-8 bg-green-600 text-white px-8 py-3 rounded-full hover:bg-green-700 transition-colors">
            Join Our Talent Pool
          </button>
        </div>
      </div>
    </div>
  );
}
